namespace GeniuzPOS.Lookups {
    export interface VwUserRow {
        UserId?: number;
        Username?: string;
        ShopId?: string;
        DisplayName?: string;
    }

    export namespace VwUserRow {
        export const idProperty = 'UserId';
        export const nameProperty = 'Username';
        export const localTextPrefix = 'Lookups.VwUser';
        export const lookupKey = 'Lookups.VwUser';

        export function getLookup(): Q.Lookup<VwUserRow> {
            return Q.getLookup<VwUserRow>('Lookups.VwUser');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            UserId = "UserId",
            Username = "Username",
            ShopId = "ShopId",
            DisplayName = "DisplayName"
        }
    }
}
